import React from 'react';
import { TableRowTimeSheet } from '../types';
import Button from '../../../../../../components/button';
import { TimeSheetStatus } from '../../../../__generated__/graphql';
import { useNamespacedTranslation } from '../../../../../../hooks/useNamespacedTranslation';

type Props = {
  timeSheetRow: TableRowTimeSheet;
  onApprove: (timeSheetRow: TableRowTimeSheet) => void;
};
export const ApproveStatusCell: React.FC<Props> = ({
  timeSheetRow,
  onApprove,
}) => {
  const controllingTableT = useNamespacedTranslation(
    'timeTracking.projects.controlling.table',
  );
  const timeSheetStatusT = useNamespacedTranslation('timeSheet.status');

  switch (timeSheetRow.approveStatus) {
    case TimeSheetStatus.Pending:
      return (
        <Button
          label={controllingTableT(`actions.approve`)}
          variant="outline-primary"
          size="sm"
          isProcessing={timeSheetRow.approving}
          onClick={() => onApprove(timeSheetRow)}
        />
      );
    case TimeSheetStatus.Approved:
      return (
        <span className="text-success">
          {timeSheetStatusT(`${timeSheetRow.approveStatus.toLowerCase()}`)}
        </span>
      );
    case TimeSheetStatus.Skipped:
    case TimeSheetStatus.Unknown:
      return (
        <span>
          {timeSheetStatusT(`${timeSheetRow.approveStatus.toLowerCase()}`)}
        </span>
      );
    default:
      return null;
  }
};
